// TableActions.js
import React from 'react';
import { IconButton } from '@mui/material';
import { AiFillEdit, AiOutlineDelete } from 'react-icons/ai';
import { FaEye } from 'react-icons/fa';

function DataGridActions({ handleEdit, handleDelete, rowData, showDetails, showDetailsStatus, canEdit = true, canDelete = true, showDelete = true }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px", padding: "0 4px" }}>
      {
        showDetailsStatus && (
          <IconButton onClick={() => showDetails?.(rowData)} aria-label="View details">
            <FaEye style={{ color: '#284945' }} />
          </IconButton>
        )
      }
      <IconButton onClick={() => canEdit && handleEdit(rowData)} disabled={!canEdit} title={canEdit ? "Edito" : "Nuk mund të editohet"}>
        <AiFillEdit style={{ color: '#466F86' }} />
      </IconButton>
      {showDelete && (
        <IconButton onClick={() => canDelete && handleDelete(rowData)} disabled={!canDelete} title={canDelete ? "Fshij" : "Nuk mund të fshihet"}>
          <AiOutlineDelete style={{ color: '#962a38' }} />
        </IconButton>
      )}
    </div>
  );
}

export default DataGridActions;
